export default "__VITE_ASSET__PSQOeDBm__"